import plant from '@kk-activity-factory/module-bundle/components/ShineCard/store/Plant/index.js';
import blinkCard from '@kk-activity-factory/module-bundle/components/ShineCard/store/BlinkCard/index.js';
import social from '@kk-activity-factory/module-bundle/components/ShineCard/store/Social/index.js';
import comment from '@kk-activity-factory/module-bundle/components/Comment/store/index.js';
import quest from '@kk-activity-factory/quest-and-assist-module/store/index.js';

const components = {
    'img-block': () =>
        import(/* webpackChunkName: "image-block" */ '@kk-activity-factory/img-module'),
    'lottery-nine-square-grid': () =>
        import(
            /* webpackChunkName: "lottery-nine-square-grid" */ '@kk-activity-factory/lottery-nine-square-grid'
        ),
    'lottery-button': () =>
        import(
            /* webpackChunkName: "lottery-button" */ '@kk-activity-factory/lottery-button/index.vue'
        ),
    'draw-shine-card': () =>
        import(
            /* webpackChunkName: "draw-shine-card" */ '@kk-activity-factory/module-bundle/components/ShineCard/index.vue'
        ),
    'multiple-img-block': () =>
        import(
            /* webpackChunkName: "multiple-img-block" */ '@kk-activity-factory/module-bundle/components/MultipleImgBlock/index.vue'
        ),
    'multiple-img-modlue': () =>
        import(
            /* webpackChunkName: "multiple-img-modlue" */ '@kk-activity-factory/multiple-img-module'
        ),
    rule: () =>
        import(
            /* webpackChunkName: "rule" */ '@kk-activity-factory/module-bundle/components/Rule/Rule.vue'
        ),
    'prize-backpack': () =>
        import(
            /* webpackChunkName: "prize-backpack" */ '@kk-activity-factory/prize-backpack/PrizeBackpack.vue'
        ),
    'open-red-envelope': () =>
        import(
            /* webpackChunkName: "open-red-envelope" */ '@kk-activity-factory/module-bundle/components/OpenRedEnvelope/OpenRedEnvelope.vue'
        ),
    'red-envelope-rain': () =>
        import(
            /* webpackChunkName: "red-envelope-rain" */ '@kk-activity-factory/module-bundle/components/RedEnvelopeRain/RedEnvelopeRain.vue'
        ),
    'close-stay': () =>
        import(
            /* webpackChunkName: "close-stay" */ '@kk-activity-factory/module-bundle/components/CloseStay/CloseStay.vue'
        ),
    answer: () =>
        import(
            /* webpackChunkName: "answer" */ '@kk-activity-factory/module-bundle/components/Answer/Answer.vue'
        ),
    'carousel-img': () =>
        import(
            /* webpackChunkName: "carousel-img" */ '@kk-activity-factory/module-bundle/components/BannerImg/BannerImg.vue'
        ),
    'banner-v2': () => import(/* webpackChunkName: "banner-v2" */ '@kk-activity-factory/banner-v2'),
    'collect-card': () =>
        import(
            /* webpackChunkName: "collect-card" */ '@kk-activity-factory/module-bundle/components/CollectCard/index.vue'
        ),
    puzzle: () => import(/* webpackChunkName: "puzzle" */ '@kk-activity-factory/puzzle-module'),
    exchange: () =>
        import(/* webpackChunkName: "exchange" */ '@kk-activity-factory/exchange-module'),
    'button-config': () =>
        import(/* webpackChunkName: "button-module" */ '@kk-activity-factory/button-module'),
    // 任务模块；适用于 按钮定位展示 || 弹窗展示
    'quest-info': () =>
        import(/* webpackChunkName: "quest-info" */ '@kk-activity-factory/quest-and-assist-module'),
    // 注意-dialog的后缀有特定逻辑，请谨慎修改
    'quest-info-dialog': () =>
        import(
            /* webpackChunkName: "quest-info-dialog" */ '@kk-activity-factory/quest-and-assist-module/HideDialog.vue'
        ),
    'simple-video': () =>
        import(
            /* webpackChunkName: "simple-video" */ '@kk-activity-factory/module-bundle/components/SimpleVideo/index.vue'
        ),
    'winning-broadcast': () =>
        import(
            /* webpackChunkName: "winning-broadcast" */ '@kk-activity-factory/module-bundle/components/WinningBroadcast/index.vue'
        ),
    comment: () =>
        import(
            /* webpackChunkName: "comment" */ '@kk-activity-factory/module-bundle/components/Comment/index.vue'
        ),
    barrage: () =>
        import(
            /* webpackChunkName: "barrage" */ '@kk-activity-factory/module-bundle/components/Barrage/index.vue'
        ),
    'audio-comp': () =>
        import(
            /* webpackChunkName: "audio" */ '@kk-activity-factory/module-bundle/components/Audio/index.vue'
        ),
    filters: () =>
        import(/* webpackChunkName: "filters" */ '@kk-activity-factory/filter-module/index.vue'),
    'content-recommend': () =>
        import(
            /* webpackChunkName: "content-recommend" */ '@kk-activity-factory/module-bundle/components/ContentRecommend/index.vue'
        ),
    'content-recommend-v2': () =>
        import(
            /* webpackChunkName: "content-recommend-v2" */ '@kk-activity-factory/content-recommend'
        ),
    'rich-man': () =>
        import(/* webpackChunkName: "rich-man" */ '@kk-activity-factory/rich-man-module'),
    'sign-in': () =>
        import(/* webpackChunkName: "sign-in" */ '@kk-activity-factory/sign-in-module'),
    'stage-award': () =>
        import(/* webpackChunkName: "stage-award" */ '@kk-activity-factory/stage-award-module'),
    'stratification-stage-prize': () =>
        import(
            /* webpackChunkName: "stratification-stage-prize" */ '@kk-activity-factory/stratification-stage-prize'
        ),
    'realtime-reward': () =>
        import(/* webpackChunkName: "realtime-reward" */ '@kk-activity-factory/realtime-reward'),
    develop: () => import(/* webpackChunkName: "develop" */ '@kk-activity-factory/develop-module'),
    vote: () => import(/* webpackChunkName: "vote" */ '@kk-activity-factory/vote-module'),
    'prize-show': () =>
        import(
            /* webpackChunkName: "prize-show" */ '@kk-activity-factory/prize-show-module/index.vue'
        ),
    accumulator: () =>
        import(/* webpackChunkName: "accumulator" */ '@kk-activity-factory/accumulator-module'),
    rank: () =>
        import(
            /* webpackChunkName: "rank" */ '@kk-activity-factory/module-bundle/components/Rank/index.vue'
        ),
    'post-recommend': () =>
        import(
            /* webpackChunkName: "post-recommend" */ '@kk-activity-factory/module-bundle/components/PostRecommend/index.vue'
        ),
    'left-right-show': () =>
        import(
            /* webpackChunkName: "left-right-show" */ '@kk-activity-factory/module-bundle/components/LeftRightShow/index.vue'
        ),
    'enumerate-show': () =>
        import(
            /* webpackChunkName: "enumerate-show" */ '@kk-activity-factory/module-bundle/components/EnumerateShow/index.vue'
        ),
    'multiple-level-lottery': () =>
        import(
            /* webpackChunkName: "multiple-level-lottery" */ '@kk-activity-factory/multiple-level-lottery'
        ),
    'topic-rank': () =>
        import(/* webpackChunkName: "topic-rank" */ '@kk-activity-factory/topic-rank'),
    'text-module': () =>
        import(/* webpackChunkName: "text-module" */ '@kk-activity-factory/text-module'),
    'title-image-module': () =>
        import(
            /* webpackChunkName: "title-image-module" */ '@kk-activity-factory/title-image-module'
        ),
    'user-avatar': () =>
        import(/* webpackChunkName: "user-avatar" */ '@kk-activity-factory/user-avatar'),
};

const componentMap = {
    STATIC_IMG: {
        COM_STATIC_IMG: 'img-block', // 图片模块
        COM_MULTIPLE_IMG: 'multiple-img-block', // 旧固定多图模块，后台已无法创建新的，旧活动兼容保留
        ACTIVITY_RULE: 'rule',
        REWARD_BACKPACK: 'prize-backpack',
        CLOSE_STAY: 'close-stay',
        COM_MULTIPLE_IMG_NEW: 'multiple-img-modlue',
        TITLE_IMAGE: 'title-image-module',
        USER_AVATAR: 'user-avatar',
    },
    LOTTERY: {
        LOTTERY_FOR_NINE: 'lottery-nine-square-grid', // 九宫格抽奖模块
    },
    LOTTERY_BUTTON: {
        ACTIVITY_LOTTERY_BUTTON: 'lottery-button',
    },
    COLLECT_CARD: {
        COLLECT_CARD: 'collect-card',
    },
    SHINE_CARD: {
        DRAW_SHINE_CARD: 'draw-shine-card', // 抽卡模块
    },
    COMMENT: {
        ACTIVITY_COMMENT: 'comment', // 评论模块
    },
    RED_ENVELOPE_RAIN: {
        OPEN_RED_ENVELOPE: 'open-red-envelope', // 拆红包模块
        RED_ENVELOPE_RAIN_CONFIG: 'red-envelope-rain', // 红包雨模块
    },
    PROCESS_QUEST: {
        PROCESS_QUEST_CONFIG: 'quest-info', // 任务模块
    },
    ANSWER: {
        USER_ANSWER: 'answer',
    },
    ACVTIVITY_BANNER: {
        ACTIVITY_BANNER_IMG: 'carousel-img',
    },
    ACTIVITY_BANNER_V2: {
        ACTIVITY_BANNER_IMG_V2: 'banner-v2',
    },
    VIDEO: {
        ACTIVITY_VIDEO: 'simple-video',
    },
    WINNING_BROADCAST: {
        ACTIVITY_WINNING_BROADCAST: 'winning-broadcast', // 中奖播报模块
    },
    BARRAGE: {
        ACTIVITY_BARRAGE: 'barrage', // 弹幕模块
    },
    BUTTON: {
        BUTTON_CONFIG: 'button-config', // 按钮模块
    },
    PUZZLE: {
        ACTIVITY_PUZZLE: 'puzzle', // 拼图模块
    },
    AUDIO: {
        ACTIVITY_AUDIO: 'audio-comp',
    },
    TABBED_PAGE: {
        ACTIVITY_TABBED_PAGE: 'filters', // 分页模块（过滤功能）
    },
    CONTENT_RECOMMENDATION: {
        ACTIVITY_CONTENT_RECOMMENDATION: 'content-recommend', // 内容推荐模块
    },
    CONTENT_RECOMMENDATION_V2: {
        ACTIVITY_CONTENT_RECOMMENDATION_V2: 'content-recommend-v2', // 内容推荐模块新版
    },
    NON_COMMON: {
        NON_CONFIGURABLE: '',
    },
    EXCHANGE: {
        ACTIVITY_EXCHANGE: 'exchange', // 兑换模块
    },
    RICH_MAN: {
        ACTIVITY_RICH_MAN: 'rich-man', // 大富翁模块
    },
    SIGN_IN: {
        ACTIVITY_SIGN_IN: 'sign-in', // 签到模块
    },
    STAGE_PRIZE: {
        STAGE_PRIZE_CONFIG: 'stage-award', // 阶段奖励模块
        STRATIFICATION_STAGE_PRIZE: 'stratification-stage-prize', // 分层阶段奖励模块
    },
    REALTIME_REWARD: {
        ACTIVITY_REALTIME_REWARD: 'realtime-reward', // 实时奖励模块
    },
    DEVELOPMENT: {
        ACTIVITY_DEVELOPMENT: 'develop', // 养成模块
    },
    VOTE: {
        ACTIVITY_VOTE: 'vote', // 投票模块
    },
    PRIZE_SHOW: {
        ACTIVITY_PRIZE_SHOW: 'prize-show', // 奖励展示模块
    },
    STAGED_CHARGE: {
        ACTIVITY_STAGED_CHARGE: 'accumulator', // 蓄力模块
    },
    RANK: {
        ACTIVITY_RANK: 'rank', // 排行榜模块
        TOPIC_RANK: 'topic-rank', // 作品排行榜模块
    },
    POST_RECOMMEND: {
        POST_RECOMMEND: 'post-recommend', // 帖子推荐模块
    },
    VISIT: {
        ACTIVITY_VISIT: 'visit-prize', // 访问奖励模块,只支持HIDDEN，没有对应组件
        ACCESS_GUIDE: 'visit-guide', // 访问引导弹窗,只支持HIDDEN
    },
    LEFT_RIGHT_SHOW: {
        LEFT_RIGHT_SHOW: 'left-right-show', // 左右选择模块
    },
    ENUMERATE_SHOW: {
        ENUMERATE_SHOW: 'enumerate-show', // 罗列展示模块
    },
    MULTI_POSITION_LOTTERY: {
        ACTIVITY_MULTI_POSITION_LOTTERY: 'multiple-level-lottery', // 多档位抽奖模块
    },
    TEXT: {
        TEXT_CONFIG: 'text-module', // 文案模块
    },
};

const moduleStore = {
    plant,
    blinkCard,
    social,
    comment,
    quest,
};

export { components, componentMap, moduleStore };
